// extracted by mini-css-extract-plugin
export default {"partnerStyles":"Partners_partnerStyles__21BYz","partners":"Partners_partners__7ubML","overlay":"Partners_overlay__ohxKG"};